
//import { url } from "inspector";
import React, {useState} from "react";
import draw from "./d3code";
import PopUp from "./PopUp";
import "./shotChart.css"

/*interface ShotChartProps {
  player: any;
  updateHover: any;
  showHover:any;
  //xhoverIndex: number;
}
interface ShotChartState {
  popUps: any;
  hoverIndex: number
}
*/
export default class ShotChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popUps: new Array(6).fill(false),
      hoverIndex: 0
    };
  }
  componentDidMount() {
    draw(this.props);
  }
  // displayPopUp = region => {
  //   // this.setState(prevState => {
  //     // const popUps = prevState.popUps.map((display, j) => {
  //       // if (j == region) {
  //         // return !display;
  //       // } else {
  //         // return display;
  //       // }
  //     // });

  //     // return {
  //       // popUps
  //     // };
  //   // });
  //   hoverIndex = region;

  // };
  // removePopUp(){
  //   this.setState({popUps: new Array(6).fill(false)})
  // }

  render() {
    const { player, index } = this.props;
    const { nameslug } = player;
    const { pct, totals } = player;
    const { popUps } = this.state;
    //let {hoverIndex} = this.props;

    let PopUps = [];
    // for (let i = 0; i < popUps.length; i++) {
      // if (popUps[i] === true) {
      //   PopUps.push(
          // <PopUp
          //   pct={pct[hoverIndex]}
          //   totals={totals[hoverIndex]}
          //   key={`popup_${nameslug}_${hoverIndex}`}
          // />
    //     );
    //   }
    // }
    
    return (
      <>
        {/* <PopUp
            pct={pct[this.state.hoverIndex]}
            totals={totals[this.state.hoverIndex]}
            key={`popup_${nameslug}_${this.state.hoverIndex}`}
          /> */}
        <div id={`shotchart_${nameslug}`}>
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 860 900"
            fill="none"
            stroke="black"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/*Make background for interactive white so gradient shows up better*/}
            <rect
              id = 'background'
              x="13"
              y="96"
              width = "834"
              height = "706"
              />

            <path
              id = {`leftWing_${nameslug}`}
              d="M846 296.301V802H430V580C672.05 578.912 746.47 411.842 746.47 296.479Z"
              onMouseEnter={() => {this.setState({hoverIndex: 1}); this.props.updateHover(1,pct[0]/100,totals[0]["shot"])}}
              onMouseLeave={()=> this.props.showHover()}
              onClick={() => {this.setState({hoverIndex: 1}); this.props.updateHover(1,pct[0]/100,totals[0]["shot"],index)}}
              />
            <rect
              id={`leftCorner_${nameslug}`}
              x="746"
              y="96.0589"
              width="100"
              height="200"
              onMouseEnter={() => {this.setState({hoverIndex: 2}); this.props.updateHover(2,pct[1]/100, totals[1]["shot"])}}
              onMouseLeave={()=> this.props.showHover()}
              onClick={() => {this.setState({hoverIndex: 2}); this.props.updateHover(2,pct[1]/100, totals[1]["shot"],index)}}
            />
            <path
              id={`leftFG_${nameslug}`}
              d="M746.47 196.242V96H540V472C538.863 485.831 536.058 499.834 530.609 512.9C525.16 525.965 517.173 537.837 507.104 547.836C497.035 557.836 485.082 565.769 471.926 571.18C458.771 576.592 444.671 579.378 430.432 579.378C672.05 578.912 746.47 411.842 746.47 296.479V258.118V196.242Z"
              onMouseEnter={() => {this.setState({hoverIndex: 3}); this.props.updateHover(3,pct[2]/100,totals[2]["shot"])}}
              onMouseLeave={()=> this.props.showHover()}
              onClick={() => {this.setState({hoverIndex: 3}); this.props.updateHover(3,pct[2]/100,totals[2]["shot"],index)}}
            />
            <path
              id={`TopKey_${nameslug}`}
              d="M538.863 471.689C538.863 485.831 536.058 499.834 530.609 512.9C525.16 525.965 517.173 537.837 507.104 547.836C497.035 557.836 485.082 565.769 471.926 571.18C458.771 576.592 444.671 579.378 430.432 579.378C416.192 579.378 402.092 576.592 388.937 571.18C375.781 565.768 363.828 557.836 353.759 547.836C343.69 537.837 335.703 525.965 330.254 512.9C324.805 499.834 322 485.831 322 471.689L430.432 471.689H538.863Z"
              onMouseEnter={() => {this.setState({hoverIndex: 4}); this.props.updateHover(4, pct[3]/100,totals[3]["shot"])}}
              onMouseLeave={()=> this.props.showHover()}
              onClick={() => {this.setState({hoverIndex: 4}); this.props.updateHover(4, pct[3]/100,totals[3]["shot"],index)}}
            />
            <path
              id={`Paint_${nameslug}`}
              // id={`Paint_${nameslug}`}
              d="M536.935 95.9347C538.935 110.109 536.128 124.144 530.676 137.24C525.223 150.335 517.232 162.233 507.157 172.256C497.082 182.279 485.121 190.229 471.958 195.653C458.794 201.078 444.686 203.869 430.438 203.869C416.19 203.869 402.081 201.078 388.918 195.653C375.754 190.229 363.794 182.279 353.719 172.256C343.644 162.233 335.652 150.335 330.2 137.24C324.747 124.144 321.941 110.109 321.941 95.9347V472H540V96Z"//V472H322V96Z"
              onMouseEnter={() => {this.setState({hoverIndex: 5}); this.props.updateHover(5,pct[4]/100, totals[4]["shot"])}}
              onMouseLeave={()=> this.props.showHover()}
              onClick={() => {this.setState({hoverIndex: 5}); this.props.updateHover(5,pct[4]/100, totals[4]["shot"],index)}}
            />
            <path
              id={`Rim_${nameslug}`}
              d="M538.935 95.9347C538.935 110.109 536.128 124.144 530.676 137.24C525.223 150.335 517.232 162.233 507.157 172.256C497.082 182.279 485.121 190.229 471.958 195.653C458.794 201.078 444.686 203.869 430.438 203.869C416.19 203.869 402.081 201.078 388.918 195.653C375.754 190.229 363.794 182.279 353.719 172.256C343.644 162.233 335.652 150.335 330.2 137.24C324.747 124.144 321.941 110.109 321.941 95.9347L430.438 95.9347H538.935Z"
              onMouseEnter={() => {this.setState({hoverIndex: 6}); this.props.updateHover(6,pct[5]/100, totals[5]["shot"])}}
              onMouseLeave={()=> this.props.showHover()}
              onClick={() => {this.setState({hoverIndex: 6}); this.props.updateHover(6,pct[5]/100, totals[5]["shot"],index)}}
            />
            <path
              id={`rightWing_${nameslug}`}
              d="M13 296.301V802H430V580C187.695 578.971 113.276 411.901 113.276 296.538V296.301H13Z"
              onMouseEnter={() => {this.setState({hoverIndex: 7}); this.props.updateHover(7,pct[6]/100, totals[6]["shot"])}}
              onMouseLeave={()=> this.props.showHover()}
              onClick={() => {this.setState({hoverIndex: 7}); this.props.updateHover(7,pct[6]/100, totals[6]["shot"],index)}}
            />
            <path
              id={`rightFG_${nameslug}`}
              d="M113.276 196.301V96.0589H322V472A108.5 108.5 0 0 0 430.5 580C187.695 578.971 113.276 411.901 113.276 296.538V258.177V196.301Z"
              onMouseEnter={() => {this.setState({hoverIndex: 8}); this.props.updateHover(8,pct[7]/100, totals[7]["shot"])}}
              onMouseLeave={()=> this.props.showHover()}
              onClick={() => {this.setState({hoverIndex: 8}); this.props.updateHover(8,pct[7]/100, totals[7]["shot"],index)}}
            />
            <rect
              id={`rightCorner_${nameslug}`}
              x = "13"
              y="97"
              width="100"
              height="200"
              onMouseEnter={() => {this.setState({hoverIndex: 9}); this.props.updateHover(9,pct[8]/100, totals[8]["shot"])}}
              onMouseLeave={()=> this.props.showHover()}
              onClick={() => {this.setState({hoverIndex: 9}); this.props.updateHover(9,pct[8]/100, totals[8]["shot"],index)}}
            />
            <linearGradient
              id="linear-gradient"
              gradientUnits="userSpaceOnUse"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%"
              //gradientTransform="matrix(1 0 0 -1 -761.14 398.97)"
            >
              <stop offset="0%" stopColor="rgb(8, 98, 158)" stopOpacity="0%" />
              <stop offset="100%" stopColor="rgb(8, 98, 158)" stopOpacity="100%" />
            </linearGradient>
            <rect
              id={'legend_background'}
              fill="white"
              x = '35'
              y = '835'
              width = '770'
              height = '15'
            />
            <rect
              id={'legend'}
              fill="url(#linear-gradient)"
              x = '35'
              y = '835'
              width = '770'
              height = '15'
            />
            <text
              id='legend_title'
              x='350'
              y='825'
              fill='white'
              stroke = 'white'
              fontFamily="Optima"
            >
              Percentage Shooting
            </text>
            <text
              id='legend_range_right'
              x='30'
              y='870'
              fill='white'
              stroke = 'white'
              fontFamily="Optima"
            >
              0%
            </text>
            <text
              id='legend_range_left'
              x='790'
              y='870'
              fill='white'
              stroke = 'white'
              fontFamily="Optima"
            >
              100%
            </text>
          </svg>
        </div>
        {() => {}}
      </>
    );
  }
}
